import React from "react";
import TestimonialSeven from "../Testimonials/Testimonial-Seven";

const TestimonialSection = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="section-title text-center mb--10">
            <span className="subtitle bg-primary-opacity">TESTIMONIALS</span>
            <h2 className="title">
              People like ELMSPLUS education. <br /> No joking - here&apos;s the
              proof!
            </h2>
          </div>
        </div>
      </div>
      <TestimonialSeven />
    </div>
  );
};

export default TestimonialSection;
